var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 0C104.8 0 112 7.164 112 16V112H80V16C80 7.164 87.16 0 96 0zM288 0C296.8 0 304 7.164 304 16V112H272V16C272 7.164 279.2 0 288 0zM368 144C376.8 144 384 151.2 384 160C384 168.8 376.8 176 368 176H352V240C352 322.1 288.9 391.2 208 399.2V496C208 504.8 200.8 512 192 512C183.2 512 176 504.8 176 496V399.2C95.15 391.2 32 322.1 32 240V176H16C7.164 176 0 168.8 0 160C0 151.2 7.164 144 16 144H368zM192 368C262.7 368 320 310.7 320 240V176H64V240C64 310.7 121.3 368 192 368z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.1704b56cd54c27f722949eb321d95e3f.svg";
export { ForwardRef as ReactComponent };